import {axiosInstance as mantis} from "./mantis";

export const getUserDetails = (userId) => {
    return mantis.get(`/user/${userId}`);
}

export const createUser = (tenantId, username, name, company, password, email, role) => {
    const data = {
        parentTenantId: tenantId,
        name: name,
        company: company,
        username: username,
        password: password,
        email: email,
        role: role
    };
    return mantis.post("/user/", data);
};

export const editUser = (userId, name, company, password, email, role) => {
    const data = {
        name: name,
        company: company,
        email: email,
        role: role
    };
    if (password) {
        data.password = password;
    }
    return mantis.put(`/user/${userId}`, data);
};

export const deleteUser = userId => {
    return mantis.delete(`/user/${userId}`);
};
